import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b6fecb5c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../asset/css/index.scss?vue&type=style&index=0&id=b6fecb5c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fecb5c",
  null
  
)

export default component.exports